export const isRouted = (url: string) => {
    // eslint-disable-next-line no-restricted-properties -- allowed here
    return url.startsWith('/') || url.startsWith(document.location.origin)
}
